export const TrashIcon = ({ className = '', fill = '#FF001F', onClick, dataIndex }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="22"
    fill="none"
    viewBox="0 0 18 22"
    className={className}
    onClick={onClick}
    data-index={dataIndex}
  >
    <path
      fill={fill}
      // eslint-disable-next-line max-len
      d="M17.25 3.5h-4.5V2.375A1.875 1.875 0 0010.875.5h-3.75A1.875 1.875 0 005.25 2.375V3.5H.75a.75.75 0 000 1.5h.797l.89 14.293c.067 1.259 1.032 2.207 2.25 2.207h8.625c1.225 0 2.17-.927 2.25-2.203L16.453 5h.797a.75.75 0 100-1.5zm-11.223 15H6a.75.75 0 01-.75-.723l-.375-10.5a.75.75 0 011.5-.054l.375 10.5a.75.75 0 01-.723.777zm3.723-.75a.75.75 0 11-1.5 0V7.25a.75.75 0 011.5 0v10.5zm1.5-14.25h-4.5V2.375A.37.37 0 017.125 2h3.75a.371.371 0 01.375.375V3.5zm1.5 14.277a.75.75 0 01-.75.723h-.027a.75.75 0 01-.723-.777l.375-10.5a.75.75 0 011.5.054l-.375 10.5z"
    ></path>
  </svg>
)
